import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Sofia_Sans_Extra_Condensed%22,%22arguments%22:[{%22subsets%22:[%22latin%22,%22latin-ext%22],%22style%22:[%22normal%22,%22italic%22]}],%22variableName%22:%22sans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Sofia Sans Extra Condensed', 'Sofia Sans Extra Condensed Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
